export default {"src":"/newStatic/_next/static/media/hero_desktop.a7f35856.svg","height":492,"width":659};